import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { CompletionGuard } from './CompletionGuard';

/**
 * Checks if admin onboarding is complete before rendering admin routes.
 * Teachers bypass the check (onboarding is an admin-only concern).
 */
export const OnboardingGuard = ({ children }) => {
  const { isStrictAdmin } = useAuth();

  return (
    <CompletionGuard
      shouldCheck={isStrictAdmin}
      endpoint="/api/admin/onboarding"
      redirectTo="/admin/onboarding"
      backgroundClass="bg-[#F8F9FC]"
    >
      {children}
    </CompletionGuard>
  );
};

export default OnboardingGuard;
